import { createFileRoute } from "@tanstack/react-router";
import { ProfileDashboard } from "@/features/profile/components/ProfileDashboard";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import { PlansSidebar } from "@/features/planner";
import { useState, useEffect } from "react";

export const Route = createFileRoute("/profile/")({
    component: ProfilePage,
});

function ProfilePage() {
    const [showPlans, setShowPlans] = useState(false);

    // close on ESC
    useEffect(() => {
        const onKey = (e: KeyboardEvent) => e.key === "Escape" && setShowPlans(false);
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, []);

    return (
        <div className="flex flex-col min-h-screen">
            <Header onOpenPlans={() => setShowPlans(true)} />
            <main className="flex-grow">
                <ProfileDashboard onOpenPlans={() => setShowPlans(true)} />
            </main>
            <Footer />
            <PlansSidebar open={showPlans} onClose={() => setShowPlans(false)} />
        </div>
    );
}
